import styled from 'styled-components';
import { BREAKPOINT, COLOR_CI_BLUE } from '../../../config';

export const InfoLayerContainer = styled.div`
  position: relative;
  flex: 1;
  display: block;
  background: radial-gradient(at center, #e7e7e7 0, #ddd 100%);

  @media (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const InfoLayerContent = styled.div`
  width: 100%;
  text-align: center;
`;

export const InfoLayerText = styled.div`
  color: #666;
  font-size: 3em;
  font-weight: 400;
  padding: 1em;
  max-width: 70%;
  margin: 0 auto;

  p {
    margin: 0 0 1em;
  }
`;

export const InfoLayerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 5px;
  background: ${COLOR_CI_BLUE};
  color: #FFF;
  font-size: 1.5rem;
  font-weight: 600;
  padding: .8em 1em;
  line-height: 1.3;
  cursor: pointer;
  transition: background-color, color .3s ease-in-out;
  box-sizing: border-box;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.14);

  &:hover {
    background: #008ABF;
  }
`;